import { images } from '../../../Constants/ImageUrls';

export default function RatingStar(props) {
  const { rating, imageReview } = props;
  return (
    <div>
      {Array.from(new Array(5).keys())?.map((item, index) => {
        return (
          <span
            style={{
              margin: '0 2px 0 0',
            }}
            key={index}
          >
            {rating > 0 ? (
              rating > index ? (
                <img
                  // src="/images/new_filled_star.svg"
                  src={images.newFilledStar}
                  alt="filled_star"
                  width={imageReview ? '16px' : '22px'}
                  height={imageReview ? '16px' : '22px'}
                />
              ) : (
                <img
                  // src="/images/new_star_empty.svg"
                  src={images.newEmptyStar}
                  alt="empty_star"
                  width={imageReview ? '16px' : '22px'}
                  height={imageReview ? '16px' : '22px'}
                />
              )
            ) : null}
          </span>
        );
      })}
    </div>
  );
}
